var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-page page-container page-component pt-3 pb-4 position-relative text-center"},[_c('div',{staticClass:"px-md-5"},[_c('div',{staticClass:"mb-5 px-md-5",domProps:{"innerHTML":_vm._s(_vm.page.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }